// Batch 33 · fork "gates": S12 (firm report settings + the report warning link), T5 (J9 posting users), T8 (W9 corrected rows,
// rows not in the totals), EN + AR. Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B33_GATES = {
  en: {
    b33frs: {
      title: "Firm report settings",
      intro: "Used in the auditor's report. Blank settings show \"[to complete]\" in the report.",
      ethics: "Ethics requirements",
      ethicsHelp: "The relevant ethical requirements named in the report (for example: the International Code of Ethics for Professional Accountants as endorsed in the Kingdom of Saudi Arabia).",
      location: "Practice location",
      locationHelp: "The city where the firm practises, printed above the report date.",
      saved: "Firm report settings saved",
      openSettings: "Open firm settings",
    },
    a9001: {
      paramLabelPlain: { j9_authorised_approvers: "J9 authorised POSTING users (J9 tests the user who posted the entry)" },
      paramFormat: { j9_authorised_approvers: "authorised posting users (who posted the entry): {v}" },
    },
    b33w9: {
      corrected: "Corrected by management — resolved",
      correctedNote: "Corrected rows are shown as resolved and are not in the uncorrected totals.",
      notInTotals: "{n} misstatement(s) are not in the totals: {list}. Enter them on each row in the Unresolved tab.",
      reasons: {
        missing_communicated_date: "date communicated to management missing ({n})",
        missing_response: "management response missing ({n})",
        missing_reason: "reason for not correcting missing ({n})",
        missing_effect: "no effect entered ({n})",
      },
    },
  },
  ar: {
    b33frs: {
      title: "إعدادات تقرير المكتب",
      intro: "تُستخدم في تقرير مراجع الحسابات. الإعدادات الفارغة تظهر \"[يُستكمل]\" في التقرير.",
      ethics: "متطلبات أخلاقيات المهنة",
      ethicsHelp: "المتطلبات الأخلاقية ذات الصلة المذكورة في التقرير (مثلاً: الميثاق الدولي لسلوك وآداب المهنة للمحاسبين المهنيين المعتمد في المملكة العربية السعودية).",
      location: "موقع ممارسة المهنة",
      locationHelp: "المدينة التي يمارس فيها المكتب المهنة، وتُطبع فوق تاريخ التقرير.",
      saved: "حُفظت إعدادات تقرير المكتب",
      openSettings: "فتح إعدادات المكتب",
    },
    a9001: {
      paramLabelPlain: { j9_authorised_approvers: "المستخدمون المعتمدون للترحيل في J9 (يختبر J9 المستخدم الذي رحّل القيد)" },
      paramFormat: { j9_authorised_approvers: "المستخدمون المعتمدون للترحيل (من رحّل القيد): {v}" },
    },
    b33w9: {
      corrected: "صحّحته الإدارة — مُعالَج",
      correctedNote: "تظهر الأخطاء المصحّحة كمعالجة ولا تدخل في إجماليات الأخطاء غير المصحّحة.",
      notInTotals: "{n} من الأخطاء غير داخلة في الإجماليات: {list}. أدخلها في كل صف في تبويب غير المعالجة.",
      reasons: {
        missing_communicated_date: "تاريخ الإبلاغ للإدارة غير مُدخل ({n})",
        missing_response: "رد الإدارة غير مُدخل ({n})",
        missing_reason: "سبب عدم التصحيح غير مُدخل ({n})",
        missing_effect: "لا يوجد أثر مُدخل ({n})",
      },
    },
  },
};

export default I18N_B33_GATES;
